<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <h2>برای مشاهده اطلاعات از منو یک دسته بندی را انتخاب نمایید.</h2>

    <v-treeview selectable :items="items"></v-treeview>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      items: []
    };
  },
  created() {
    this.handleGetCategories();
  },
  methods: {
    handleGetCategories() {
      this.$api.get("categories/getall").then((res) => {
        this.items = res.data.categories;
      });
    }
  }
};
</script>
